import { render, staticRenderFns } from "./Projects_View.vue?vue&type=template&id=278bb9d4&scoped=true&"
import script from "./Projects_View.vue?vue&type=script&lang=js&"
export * from "./Projects_View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278bb9d4",
  null
  
)

export default component.exports